<template>
  <v-app>
    <RouterView v-if="!isMaintenanceMode" />
    <MaintenancePage v-else />
  </v-app>

  <v-snackbar
    v-model="notif.visible"
    :color="notif.kind"
    variant="flat"
    location="top center"
    class="top-[70px] snackbar-full-width"
  >
    <div class="d-flex align-center flex-1 min-w-0">
      <v-icon class="mr-2 shrink-0">
        {{ notif.kind === "error" ? "mdi-alert-circle" : "mdi-check-circle" }}
      </v-icon>
      <span class="text-wrap break-words">{{ notif.message }}</span>
    </div>
    <template v-slot:actions>
      <v-btn class="text-none" variant="text" @click="notif.visible = false">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style scoped>
.snackbar-full-width :deep(.v-snackbar__wrapper) {
  max-width: min(95vw, 900px);
  width: fit-content;
}
.snackbar-full-width :deep(.v-snackbar__content) {
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
}
</style>
<style>
.vuejs3-datepicker__calendar {
  z-index: 1050 !important;
}

.swal2-actions button {
  color: white;
}
button.btn-danger,
button.btn_cari {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}

button.btn_cari:hover {
  color: #fff;
  background-color: #c82333;
  border-color: #bd2130;
}

#content {
  background: #ffffff url("@/assets/images/bg_infokontraktor.png") no-repeat;
  background-position: right 0rem top -1rem;
}
@font-face {
  font-family: "Inter-Black";
  src: local("Inter-Black"),
    url(./assets/fonts/inter/Inter-Black.ttf) format("truetype");
}
@font-face {
  font-family: "Inter-Regular";
  src: local("Inter-Regular"),
    url(./assets/fonts/inter/Inter-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Inter-Medium";
  src: local("Inter-Medium"),
    url(./assets/fonts/inter/Inter-Medium.ttf) format("truetype");
}
@font-face {
  font-family: "Inter-Bold";
  src: local("Inter-Bold"),
    url(./assets/fonts/inter/Inter-Bold.ttf) format("truetype");
}
@font-face {
  font-family: "Inter-SemiBold";
  src: local("Inter-SemiBold"),
    url(./assets/fonts/inter/Inter-SemiBold.ttf) format("truetype");
}
@font-face {
  font-family: "Inter-Thin";
  src: local("Inter-Thin"),
    url(./assets/fonts/inter/Inter-Thin-BETA.ttf) format("truetype");
}
.bg-red-ss {
  background-color: #f8d7da;
}
.rounded-top-10 {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
</style>
<script setup>
import { notifStore } from "@/stores/notif.js";
const notif = notifStore();
</script>

<script>
import MaintenancePage from "@/components/MaintenancePage.vue";
import { API_BASE_URL, CMS_MAINTENANCE_MODE } from "@/constants";

const url_maintenance_mode = API_BASE_URL + CMS_MAINTENANCE_MODE;
export default {
  data() {
    return {
      isMaintenanceMode: false, // Initial state assuming the site is live
    };
  },
  components: {
    MaintenancePage,
  },
  created() {
    this.checkMaintenanceStatus();
  },
  methods: {
    async checkMaintenanceStatus() {
      try {
        const response = await fetch(url_maintenance_mode);
        const data = await response.json();
        this.isMaintenanceMode = data.isMaintenanceMode;
      } catch (error) {
        console.error("Error fetching maintenance status:", error);
      }
    },
  },
};
</script>
